import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Container, Grid, Typography, IconButton, Divider, Stack } from '@mui/material';
import { Facebook, Twitter, Instagram, LinkedIn, Phone, Email, LocationOn } from '@mui/icons-material';

const Footer = () => {
  return (
    <Box component="footer" sx={{ bgcolor: '#0a0a0a', color: 'white', py: 4, mt: 'auto', position: 'relative' }}>
      <Container maxWidth="xl">
        <Grid container spacing={2}>
          {/* Brand Column */}
          <Grid item xs={12} md={4}>
            <Typography variant="h5" sx={{ fontWeight: 800, mb: 1.5, color: '#d49b7b', letterSpacing: 2 }}>
              MARVELOUS
            </Typography>
            <Typography variant="body2" sx={{ opacity: 0.6, mb: 2, lineHeight: 1.6 }}>
              Luxury real estate and hospitality services, combining property excellence with impeccable guest experiences.
            </Typography>
            <Box sx={{ display: 'flex', gap: 2 }}>
              {[Facebook, Twitter, Instagram, LinkedIn].map((Icon, i) => (
                <IconButton 
                  key={i} 
                  sx={{ 
                    color: '#d49b7b', 
                    '&:hover': { 
                      opacity: 1, 
                      transform: 'scale(1.2)',
                      bgcolor: 'rgba(212,155,123,0.1)',
                    },
                    transition: 'all 0.3s',
                  }}
                >
                  <Icon fontSize="small" />
                </IconButton>
              ))}
            </Box>
          </Grid>

          {/* Quick Links - mirror main navigation */}
          <Grid item xs={12} md={4}>
            <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1.5, color: '#d49b7b' }}>
              Explore
            </Typography>
            <Stack spacing={0.75}>
              {['Home', 'Real Estate', 'Hospitality', 'Services', 'Contact', 'About Us'].map((item) => {
                const to =
                  item === 'Home'
                    ? '/'
                    : item === 'About Us'
                    ? '/about'
                    : `/${item.toLowerCase().replace(' ', '-')}`;

                return (
                  <Link
                    key={item}
                    to={to}
                    style={{ textDecoration: 'none' }}
                  >
                    <Typography 
                      variant="body2" 
                      sx={{ 
                        color: 'white', 
                        opacity: 0.6, 
                        '&:hover': { opacity: 1, color: '#d49b7b', transform: 'translateX(5px)' }, 
                        transition: 'all 0.3s',
                        display: 'inline-block',
                      }}
                    >
                      {item}
                    </Typography>
                  </Link>
                );
              })}
            </Stack>
          </Grid>

          {/* Contact */}
          <Grid item xs={12} md={4}>
            <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1.5, color: '#d49b7b' }}>
              Contact Us
            </Typography>
            <Stack spacing={1.2}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Phone sx={{ fontSize: 18, color: '#d49b7b', opacity: 0.8 }} />
                <Typography variant="body2" sx={{ opacity: 0.7, transition: 'all 0.3s', '&:hover': { opacity: 1, color: '#d49b7b' } }}>
                  +91 98765 43210
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Email sx={{ fontSize: 18, color: '#d49b7b', opacity: 0.8 }} />
                <Typography variant="body2" sx={{ opacity: 0.7, transition: 'all 0.3s', '&:hover': { opacity: 1, color: '#d49b7b' } }}>
                  info@marvellous.com
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <LocationOn sx={{ fontSize: 18, color: '#d49b7b', opacity: 0.8 }} />
                <Typography variant="body2" sx={{ opacity: 0.7, transition: 'all 0.3s', '&:hover': { opacity: 1, color: '#d49b7b' } }}>
                  Mumbai & Pune, India
                </Typography>
              </Box>
            </Stack>
          </Grid>
        </Grid>
        
        <Divider sx={{ mt: 3, mb: 2, borderColor: 'rgba(255,255,255,0.1)' }} />
        
        {/* Copyright */}
        <Typography
          variant="caption"
          sx={{ opacity: 0.4, textAlign: 'center', display: 'block' }}
        >
          © {new Date().getFullYear()} Marvelous. All rights reserved. Luxury Real Estate & Hospitality.
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;